import { useEffect, useState } from "react";
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import styled from "styled-components";
import { SearchIcon } from "../../assets/icons/Icons";
import { ListSearch } from "../../components/ui";
import { useDebouncedSearch } from "../../hooks/useDebounce";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  & .Mui-disabled {
    background-color: var(--neutrals-cloud-gray);
    border-radius: 8px;
  };
  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

export const SearchBar = ({
  placeholder,
  register,
  typeInput = "text",
  nameKey,
  dataToSearch = [],
  lengthList,
  maxHeight,
  messageNotFound,
  setDataSelected,
  onChange = null,
  loadingSearch,
  // Data main
  dataSearched,
  setDataSearched = () => {},
  value = "",
  setValue = () => {},
  messageData = "",
  setMessageData,
  nullable = false,
  disabled = false,
  ...otherProps
}) => {
  const [valueSelected, setValueSelected] = useState("");

  const handleChange = (value) => {
    if ((value !== "" ||nullable) && onChange) {
      onChange(value);
    }
    if (setMessageData) setMessageData("");
    setDataSearched([]);
    setValue(value);
  };

  const [debouncedResults] = useDebouncedSearch(handleChange);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  }, [debouncedResults]);

  return (
    <Container {...otherProps}>
      <FormControl>
        <OutlinedInput
          {...register}
          type={typeInput}
          value={valueSelected}
          onChange={(e) => {
            setValueSelected(e.target.value);
            debouncedResults(e.target.value);
          }}
          size="small"
          sx={{ borderRadius: "8px", background: "#fff" }}
          placeholder={placeholder}
          disabled={disabled}
          endAdornment={
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          }
        />
        <ListSearch
          setValueSelected={setValueSelected}
          setDataSelected={setDataSelected}
          dataSearched={dataSearched}
          setDataSearched={setDataSearched}
          onListSearch={value}
          setOnListSearch={setValue}
          lengthList={lengthList}
          maxHeight={maxHeight}
          messageNotFound={messageNotFound}
          nameKey={nameKey}
          messageData={messageData}
        />
      </FormControl>
    </Container>
  );
};
